
document.addEventListener("DOMContentLoaded", function () {
  const tags = document.querySelectorAll(".recentTags-list .tags-list-item");

  tags.forEach(tag => {
    tag.addEventListener("click", function () {

      // remove active from all
      tags.forEach(t => t.classList.remove("active"));

      // add active to clicked
      this.classList.add("active");

    });
  });
});